import React from 'react';
import styled from '@emotion/styled';
import { useHistory } from 'react-router-dom';
import { EmotionBreakpoint, BrandUtil } from 'dw-us-ui';

const PaginationContainer = styled.div`
  ${EmotionBreakpoint('desktop')} {
    max-width: 970px;
  }
  ${EmotionBreakpoint('tablet')} {
    max-width: 720px;
  }
  ${EmotionBreakpoint('mobile')} {
    max-width: 540px;
  }
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 16px;
  .pagination-inner {
    align-items: center;
    display: flex;
    justify-content: flex-end;
    padding: 0.6rem 0;
    .pagination-label {
      margin-right: 0.6rem;
      list-style: none;
    }
    .pagination-button {
      border: 1px solid #ccc;
      color: #969696;
      align-items: center;
      display: flex;
      height: 2rem;
      justify-content: center;
      width: 2rem;
      background: white;
      border: ${({ theme }) => `0.1rem solid ${theme.button.primary.backgroundColor}`};
      color: ${({ theme }) => theme.button.primary.backgroundColor};
    }
    .pagination-button:disabled,
    .pagination-button[disabled] {
      border-color: #ccc !important;
      color: #969696 !important;
    }
    .pagination-current {
      border: 0.1rem solid #ccc;
      height: 32px;
      width: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0px 6px;
    }
    .pagination-current a {
      color: #000;
    }
    .pagination-button a {
      color: ${({ theme }) => theme.button.primary.backgroundColor};
    }
  }
`;

const Pagination = ({ current, total, next, prev, updatePageNo }) => {
  const history = useHistory();
  const brand = BrandUtil.getBrand();
  const brandTag = BrandUtil.content(brand).tag.toLowerCase();
  const buttonHandler = (e, buttonDir) => {
    e.preventDefault();
    const prevClicked = buttonDir === 'prev';
    const nextClicked = buttonDir === 'next';
    const isFirstPage = current === 1;
    const isTotalPage = current === total;
    const isFirstClicked = buttonDir === 1;
    const isNumberClicked = typeof buttonDir === 'number';
    if ((prevClicked && isFirstPage) || (nextClicked && isTotalPage)) {
      return false;
    }
    if (isNumberClicked && isFirstClicked) {
      const queryParams = history?.location?.search.replace(`?page=${current}`, '');
      history.replace({
        search: queryParams || '',
      });
    }
    updatePageNo(buttonDir);
    if (isNumberClicked && !isFirstClicked && buttonDir !== current) {
      history.push(`?page=${buttonDir}`);
    }
    return false;
  };

  return (
    <PaginationContainer>
      <ul className="pagination-inner">
        <li className="pagination-label">
          <b>Page {current}</b> of {total}
        </li>
        <li className={`pagination-${prev ? 'current' : 'button'} left-arrow`}>
          <a onClick={e => buttonHandler(e, 'prev')} href="#" aria-current="page">
            <img
              src={`/images/us/common/icons/${brandTag}/angle_left_${prev ? 'gray' : 'primary'}.svg`}
              height="12px"
              width="12px"
              alt="chevron left"
            />
          </a>
        </li>
        {[...Array(total)].map((item, i) => (
          <li key={i + 1} className={current === i + 1 ? 'pagination-button' : 'pagination-current'}>
            <a onClick={e => buttonHandler(e, i + 1)} href={`?page=${i + 1}`} aria-current="page">
              {i + 1}
            </a>
          </li>
        ))}
        <li className={`pagination-${next ? 'current' : 'button'} left-arrow`}>
          <a onClick={e => buttonHandler(e, 'next')} href="#" aria-current="page">
            <img
              src={`/images/us/common/icons/${brandTag}/angle_right_${next ? 'gray' : 'primary'}.svg`}
              height="12px"
              width="12px"
              alt="chevron right"
            />
          </a>
        </li>
      </ul>
    </PaginationContainer>
  );
};

export { Pagination };
